import { Miniature } from '../models';

export enum IdentifierMiniaturesName {
    Measured = 'measuredIdentifier',
    Calculated = 'identifier',
    Linked = 'linkedIdentifier',
    Validated = 'validatedIdentifier',
    Target = 'targetIdentifier',
    TotalPenalty = 'recresTotalPenalty',
    ReconciliationStatus = 'recresReconciliationStatus'
}

export class MeasuredIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.Measured, 'Measured identifier', 'fa-tag', ['A new measured identifier']);
    }
}

export class IdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.Calculated, 'Calculated identifier', 'fa-calculator', ['A new calculated identifier']);
    }
}

export class LinkedIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.Linked, 'Linked identifier', 'fa-link', ['A new linked identifier']);
    }
}

export class ValidatedIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.Validated, 'Validated identifier', 'fa-check-square-o', ['A new validated identifier']);
    }
}

export class TargetIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.Target, 'Target identifier', 'fa-dot-circle-o', ['A new target identifier']);
    }
}

export class TotalPenaltyIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.TotalPenalty, 'Total penalty', 'fa-exclamation-triangle', ['Total penalty of reconciled identifiers']);
    }
}

export class ReconciliationStatusIdentifierMiniature extends Miniature {
    constructor() {
        super(IdentifierMiniaturesName.ReconciliationStatus, 'Reconciliation status', 'fa-smile-o', ['ReconciliationStatus']);
    }
}